// queries.js

import { gql } from "@apollo/client";

export const GET_TRANSACTION_CHOICES = gql`
  query transactionChoices {
    transactionPlatforms
    transactionVendors
    purchaseTypes
    grids
  }
`;
